// client/src/components/marketer/project/modals/RewardModal.js
import React, { useState } from 'react';
import { API_URL } from '../constants';
import '../../../../styles/marketer/modals/RewardModal.css';

export default function RewardModal({ open, onClose, projectId, initialReward, onSaved }) {
  const [rwd, setRwd] = useState(initialReward?.rewardPointPerCreator ?? '');
  const [head, setHead] = useState(initialReward?.headcount ?? '');
  const [saving, setSaving] = useState(false);
  if (!open) return null;

  const parsedReward = Number(rwd);
  const parsedHead = Number(head);
  
  // ✅ 수정: 0도 유효한 값으로 인정, 빈 문자열만 거부
  const isRewardValid = rwd !== '' && Number.isFinite(parsedReward) && parsedReward >= 0;
  const isHeadValid = Number.isInteger(parsedHead) && parsedHead >= 1 && parsedHead <= 100;
  const valid = isRewardValid && isHeadValid;

  // 예상 계약금 계산
  const calcBaseOp = (headcount) => {
    const h = Number(headcount || 0);
    return Math.ceil(Math.max(0, h) / 3) * 5000;
  };
  
  const baseOp = valid ? calcBaseOp(parsedHead) : 0;
  const rewardTotal = valid ? parsedHead * parsedReward : 0;
  const estimatedDeposit = baseOp + rewardTotal;

  const save = async () => {
    if (!projectId) { alert('먼저 1단계를 저장해주세요.'); return; }
    if (!valid) { alert('리워드는 0 이상, 모집인원은 1~100 사이의 정수여야 합니다.'); return; }

    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/marketer/mybiz/projects/${encodeURIComponent(projectId)}/reward`, {
        method: 'PATCH', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rewardPointPerCreator: parsedReward, headcount: parsedHead })
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) throw new Error(j?.message || '저장 실패');

      onSaved({ rewardPointPerCreator: parsedReward, headcount: parsedHead });
      onClose();
    } catch (e) { alert(e.message || '저장 실패'); }
    setSaving(false);
  };

  return (
    <div className="reward-modal mbm-overlay">
      <div className="reward-modal__content mbm">
        <button onClick={onClose} aria-label="close" className="reward-modal__close mbm-close">×</button>
        <div className="reward-modal__header">
          <div className="reward-modal__title mbm-title">보상리워드와 모집 인원을 선택해주세요.</div>
        </div>

        <div className="reward-modal__grid">
          <div className="reward-modal__field">
            <div className="reward-modal__label">보상리워드 설정 (1명당)</div>
            <input 
              type="number" 
              min={0} 
              placeholder="0 이상 숫자 입력 (0 가능)" 
              value={rwd} 
              onChange={e=>setRwd(e.target.value)} 
              className="reward-modal__input"
            />
            {/* ✅ 추가: 0 포인트 가능 안내 */}
            <div className="reward-modal__hint">
              * 0 포인트로도 설정 가능합니다
            </div>
          </div>
          <div className="reward-modal__field">
            <div className="reward-modal__label">모집인원 입력</div>
            <input type="number" min={1} max={100} placeholder="1~100 숫자 입력" value={head} onChange={e=>setHead(e.target.value)} className="reward-modal__input" />
          </div>
        </div>

        {valid && (
          <div className="reward-modal__estimate">
            <div className="reward-modal__estimate-title">💰 예상 계약금 (기본)</div>
            <div className="reward-modal__estimate-amount">{estimatedDeposit.toLocaleString()} 포인트</div>
            <div className="reward-modal__estimate-detail">
              기본 운영금 {baseOp.toLocaleString()} + 결과물 리워드 {rewardTotal.toLocaleString()}
            </div>
            <div className="reward-modal__estimate-note">
              * 성과형 리워드(CPS)를 추가하면 계약금이 증가합니다.
            </div>
          </div>
        )}

        <div className="reward-modal__actions mbm-foot">
          <button type="button" onClick={save} disabled={saving || !valid} className={`reward-modal__button reward-modal__button--submit mb-btn mb-btn-primary ${saving || !valid ? 'reward-modal__button--disabled' : ''}`}>
            {saving ? '저장 중...' : '확 인'}
          </button>
        </div>
      </div>
    </div>
  );
}